import { falExclamationTriangle } from 'shared/@generated/icons/falExclamationTriangle';
import { memo, useMemo } from 'react';
import { Props } from 'shared/@types';
import { KeyValueErrors } from 'shared/library/use-api';
import { View } from 'react-native';
import { Icon } from 'shared/components/icon';
import { Text } from 'shared/components/text';

interface InputErrorProps extends Props {
  field?: string;
  title?: string;
  errors: KeyValueErrors;
}

const InputError = memo(({ errors, field, title, children }: InputErrorProps) => {
  const error: string | null = useMemo(() => {
    const errorKey = Object.keys(errors).find((key) => key === field || field === undefined);

    return errorKey ? errors[errorKey]!.join(' ') : null;
  }, [errors, field]);

  return error ? (
    <View className={'mt-1.5 flex-row overflow-hidden rounded border border-red-950/10 bg-red-100'}>
      <View className={'justify-center bg-red-100 p-3'}>
        <Icon icon={falExclamationTriangle} className={'text-red-600'} />
      </View>

      <View className={'flex-1 overflow-hidden p-3 pl-0'}>
        {title && <Text className={'font-semibold text-red-950'}>{title}</Text>}
        <Text className={'text-red-950'}>{error}</Text>
        {children}
      </View>
    </View>
  ) : null;
});

InputError.displayName = 'InputError';

export { InputError };
